import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('rejuven_token'));

  useEffect(() => {
    const initAuth = async () => {
      const savedToken = localStorage.getItem('rejuven_token');
      const savedUser = localStorage.getItem('rejuven_user');
      
      if (savedToken && savedUser) {
        try {
          setToken(savedToken);
          const response = await authAPI.getMe();
          setUser(response.data);
          localStorage.setItem('rejuven_user', JSON.stringify(response.data));
        } catch (error) {
          console.error('Auth init error:', error);
          localStorage.removeItem('rejuven_token');
          localStorage.removeItem('rejuven_user');
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };
    
    initAuth();
  }, []);

  const login = async (email, password) => {
    const response = await authAPI.login({ email, password });
    const { token: newToken, user: userData } = response.data;
    
    localStorage.setItem('rejuven_token', newToken);
    localStorage.setItem('rejuven_user', JSON.stringify(userData));
    setToken(newToken);
    setUser(userData);
    
    return userData;
  };

  const register = async (email, password, name, inviteToken) => {
    const response = await authAPI.register({ email, password, name, invite_token: inviteToken });
    const { token: newToken, user: userData } = response.data;
    
    localStorage.setItem('rejuven_token', newToken);
    localStorage.setItem('rejuven_user', JSON.stringify(userData));
    setToken(newToken);
    setUser(userData);
    
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('rejuven_token');
    localStorage.removeItem('rejuven_user');
    setToken(null);
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('rejuven_user', JSON.stringify(userData));
  };

  const value = {
    user,
    token,
    loading,
    login,
    register,
    logout,
    updateUser,
    isAuthenticated: !!token && !!user,
    isAdmin: user?.is_admin || false,
    needsOnboarding: user && !user.onboarding_completed,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
